module.exports = __webpack_public_path__ + "static/media/ionicons.e74f7161.woff";